import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import {
    setListSelectedIds as setListSelectedIdsAction,
    translate
} from 'react-admin';
import MaterialUiButton from '@material-ui/core/Button';

const styles = {
    button: { marginRight: '1em', marginLeft: '1em' },
};

class UnselectAllButton extends Component {
    handleClick = () => {
        this.props.setSelectedIds(this.props.resource, []);
    };

    render() {
        const { translate } = this.props; 
        return (
            <MaterialUiButton variant="outlined" onClick={this.handleClick} style={styles.button} color="primary">
                {translate('common.unselectAll')}
            </MaterialUiButton>
        );
    }
}

const enhance = compose(
    translate,
    connect(
        undefined,
        { setSelectedIds: setListSelectedIdsAction }
    )
);

export default enhance(UnselectAllButton);